module.exports = function() {
  return new Worker(__webpack_public_path__ + "1ed9aba1f86377317a0e.worker.js");
};